import {observable, action} from 'mobx';

class ExamPrepHeaderStore {
  @observable topic = {};
  @observable showButtons = false;

  @action
  setTopic = (topic) => {
    this.topic = topic;

    if (topic.id) {
      this.showButtons = true;
    }
  };

  @action
  clear = () => {
    this.topic = {};
    this.showButtons = false;
  };
}

export default new ExamPrepHeaderStore();


// WEBPACK FOOTER //
// ./src/stores/examPrepHeader.js